import createIcon from '../../createIcon';

/**
 * @component @name Vignette
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxOUMxIDIwLjEgMS45IDIxIDMgMjFIMjFDMjIuMSAyMSAyMyAyMC4xIDIzIDE5VjVDMjMgMy45IDIyLjEgMyAyMSAzWk0xMiAxOEM3LjU4IDE4IDQgMTUuMzEgNCAxMkM0IDguNjkgNy41OCA2IDEyIDZDMTYuNDIgNiAyMCA4LjY5IDIwIDEyQzIwIDE1LjMxIDE2LjQyIDE4IDEyIDE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Vignette = createIcon('Vignette', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM12 18C7.58 18 4 15.31 4 12C4 8.69 7.58 6 12 6C16.42 6 20 8.69 20 12C20 15.31 16.42 18 12 18Z',
      key: '1b4rhp',
    },
  ],
]);

export default Vignette;
